export default __webpack_public_path__ + "static/media/PAYROLL-definitions.c5272f75.png";